import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-card-desktop',
  templateUrl: './card-desktop.component.html',
  styleUrls: ['./card-desktop.component.scss']
})
export class CardDesktopComponent implements OnInit {

  @Input() data: Record<string, any>;
  trustedCards: Array<Record<string, any>> = [];

  constructor(
    private sanitiser: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.trustedCards = this.data.page_card.map(c => {
      const newC = c;
      newC.trustedDesc = this.sanitiser.bypassSecurityTrustHtml(c.description);
      return newC;
    })
  }

}
